import {Component} from '@angular/core';
import {AbstractEditOrmComponent} from "../../AbstractEditOrmComponent";
import {Monitoramento} from "../../../../domain/Monitoramento";
import {Projeto} from "../../../../domain/Projeto";
import {
  AtributoEspecime,
  AtributoMonitoramento,
  EstacaoChuva,
  Estrato,
  FaseLunar,
  Grupo, Posicao
} from "../../../../domain/enums";
import {ModalController} from "@ionic/angular";
import {EditProjetoComponent} from "../../projeto/edit-projeto/edit-projeto.component";
import {Not} from "typeorm";

@Component({
  selector: 'app-monitoramento',
  templateUrl: './edit-monitoramento.component.html',
  styleUrls: ['./edit-monitoramento.component.scss'],
})
export class EditMonitoramentoComponent extends AbstractEditOrmComponent<Monitoramento>  {
  agenciavel = true
  target = Monitoramento
  projetos: Projeto[] = []
  estacoes = Object.values(EstacaoChuva)
  fasesLunares = Object.values(FaseLunar)
  estratos = Object.values(Estrato)
  posicoes = Object.values(Posicao)
  urlListagem = "/registro/monitoramento"
  override relations = ["projeto","campanha","local","metodos","projeto.metodologias","projeto.campanhas"]
  constructor() {
    super()
    this.ds.getRepository(Projeto)
      .find({
        relations: ['metodologias','campanhas'],
        where: {excluido: Not(true)},
        order: {nome: "asc"}
      })
      .then(b=> this.projetos = b)
  }
  get exibeFaseLunar(): boolean {
    const grupos = this.entidade?.metodos?.map((m: any) => m.grupo)
    return grupos?.includes(Grupo.QPF)
  }


  exibir(nomeCampo: AtributoMonitoramento):boolean {
    // if(!this.entidade.metodos || this.entidade.metodos?.length == 0) return false
    const atributos = this.entidade.metodos?.flatMap(m=> m.listaAtributos)
    return atributos?.find(a=> a == nomeCampo) != undefined
    // return this.ctlExibir.exibir(nomeCampo, this.entidade)
  }

  async addProjeto(){
    const projeto = new Projeto()
    projeto.agencia_sigla = localStorage.getItem("agencia")
    projeto.inicio = new Date()
    projeto.arquivos = []

    const modal = await this.modalCtrl.create({
      component: EditProjetoComponent,
      componentProps: {
        entidade: projeto,
        dialogo: true,
        novo: true
      }
    })
    await modal.present()
    const {data, role} = await modal.onWillDismiss()
    if(role == 'confirm') {
      if(!this.projetos) this.projetos = []
      this.projetos.push(data)
      this.entidade.projeto = data
    }
  }

  protected readonly AtributoMonitoramento = AtributoMonitoramento;
}
